import React from 'react';
import { ReactCountDataTableTitle } from '@metarouter-private/mr-mui';

import { useAnalyticsFilesTableContext } from '../AnalyticsFilesTableContext';

const COUNT_TITLE_PROPS = {
  title: {
    singular: 'Analytics File',
    plural: 'Analytics Files',
  },
  showChipLabel: false,
};

export default function AnalyticsFilesCountTitle() {
  const { pagination } = useAnalyticsFilesTableContext();
  const count = pagination.count ?? 0;

  return <ReactCountDataTableTitle {...COUNT_TITLE_PROPS} count={count} />;
}
